export const SEND_MESSAGE_URL = '/floatChat'
export const USER_TYPING_EVENT_URL = '/socket/real'
export const RATE_CONVERSATION_QUALITY = '/rate'
export const SET_CONVERSATION_SEEN_BY_USER_URL = '/socket/conversation/removeNotSeen'
export const TALK_WITH_OPERATOR_INSTEAD_OF_BOT_URL = '/socket/conversation/bot'
export const GET_MORE_CHATS_OF_CONVERSATION_URL = '/chats/getMore'
export const SUBMIT_FORM_DATA_URL = '/v2/socket/userDetail'
export const ADD_TO_ROOM_USER_URL = '/socket/onlyAddToRoom'
export const GET_USER_DATA_URL = '/newvisitor'
export const UPDATE_USER_DATA_URL = '/socket/userDetail'
